import { render, staticRenderFns } from "./HeaderDialog.vue?vue&type=template&id=000be3ce"
import script from "./HeaderDialog.vue?vue&type=script&lang=ts"
export * from "./HeaderDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./header.fr.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc1600359583%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fheader%2FHeaderDialog.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./header.en.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc1600359583%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fheader%2FHeaderDialog.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports